import React, { ReactElement, cloneElement } from 'react';
import { HStack, Text } from '@chakra-ui/react';
import { LinkStackProps } from 'types/NavigationBarDesktop';

export const LinkStack = ({
  iconInactive,
  iconActive,
  hasTitle,
  title,
  isActive,
}: LinkStackProps): ReactElement => {
  const Glyph = isActive && iconActive != null ? iconActive : iconInactive;
  return (
    <HStack px="xl">
      {cloneElement(Glyph, {
        ...Glyph.props,
        color: isActive ? 'text.onAccent' : 'menu.icon.secondary',
        w: '24px',
        h: '24px',
      })}
      {hasTitle && (
        <Text
          textAlign="left"
          textStyle="body.m.medium"
          color={isActive ? 'text.onAccent' : 'menu.text.secondary'}
        >
          {title}
        </Text>
      )}
    </HStack>
  );
};
